/**
 * AIGeneratorDialog — paste-text-to-slides flow (powered by /api/projects/generate-slides).
 */
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";

export default function AIGeneratorDialog({
  t, open, onOpenChange,
  textContent, setTextContent,
  isSong, setIsSong,
  generating, onGenerate,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-amber-500" />
            {t("ai_slide_generator") || "AI Slide Generator"}
          </DialogTitle>
          <DialogDescription>
            {t("ai_slide_generator_desc") || "Paste or type text content to generate slides"}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="flex items-center justify-between p-3 bg-amber-50 dark:bg-amber-950/30 rounded-lg">
            <div>
              <Label>{t("song_lyrics_mode") || "Song/Lyrics Mode"}</Label>
              <p className="text-xs text-muted-foreground">{t("ai_format_lyrics") || "AI will format as worship lyrics"}</p>
            </div>
            <Switch checked={isSong} onCheckedChange={setIsSong} />
          </div>
          <Textarea
            placeholder={isSong
              ? (t("paste_lyrics_placeholder") || "Paste song lyrics here...\n\nVerse 1:\nAmazing grace, how sweet the sound...")
              : (t("paste_content_placeholder") || "Paste or type your content here...\n\nThe AI will automatically create slides from your text.")}
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            rows={12}
            className="font-mono text-sm"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t("cancel")}</Button>
          <Button onClick={onGenerate} disabled={generating} className="gap-2">
            {generating ? (
              <>
                <motion.div animate={{ rotate: 360 }} transition={{ duration: 1, repeat: Infinity, ease: "linear" }}>
                  <Sparkles className="w-4 h-4" />
                </motion.div>
                {t("generating") || "Generating..."}
              </>
            ) : (
              <>
                <Sparkles className="w-4 h-4" />
                {t("generate_slides") || "Generate Slides"}
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
